<template>
  <span v-if="trend !== 'NONE'" class="ml-2 text-lg" :class="trendClass">
    {{ trendIcon }}
  </span>
</template>

<script>
export default {
  name: 'Trend',

  props: {
    trend: { // Se llenará con "UP", "DOWN", "SAME" o "NONE"
      type: String,
      required: true
    }
  },

  computed: {
    trendClass() {
      const classes = {
        UP: 'text-green-500',
        DOWN: 'text-red-500',
        SAME: 'text-gray-500'
      };
      return classes[this.trend] || '';
    },
    trendIcon() {
      const icons = {
        UP: '↑',
        DOWN: '↓',
        SAME: '→'
      };
      return icons[this.trend] || '';
    }
  }
};
</script>